<template>
  <div class="content">
    <div class="Home" v-if="isin">
      <!--中文版 -->
      <div>
        <div class="main">
          <div class="toast" v-show="toastShow">
            {{ toasttext }}
          </div>
          <!-- <div class="text stext" id="text">
            <div id="onee" style="transition: all 500ms ease 0s;">
              更及时的园区动态
            </div>
            <div id="twoo" style="transition: all 500ms ease 0s;">
              更全面的园区信息
            </div>
            <div id="threee" style="transition: all 500ms ease 0s;">
              更生动的主题故事
            </div>
          </div> -->
          <div class="Tips">
            <div
              style="
                display: flex;
                justify-content: space-between;
                width: 110%;
                transform: scale(0.9);
                position: relative;
                left: -18px;
              "
            >
              <div class="developer">开发者：尤尼维瑟(北京)咨询有限公司</div>
              <div class="edition">北京环球度假区 {{ version }}</div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: 7px;
                width: 110%;
                transform: scale(0.9);
                position: relative;
                left: -18px;
              "
            >
              <div class="operate">
                <span @click="power">权限</span> |
                <span @click="privacy">隐私政策</span>
              </div>
              <div class="renew">{{ updateDate }}更新</div>
            </div>
          </div>
          <div class="bo-1">
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide
                class="one"
              >
                <div id="onee" :class="['title', { 'title-hidden': activeSlide !== 0 }]">
                  更及时的园区动态
                </div>
                <img class="img1" src="../../assets/img/d-1-3.png" alt="" />
                <div class="imgsilde">
                  <img
                    class="img2"
                    src="../../assets/img/logo-apng.png"
                    alt=""
                  />
                </div>
              </swiper-slide>

              <swiper-slide class="two">
                <div id="twoo" :class="['title', { 'title-hidden': activeSlide !== 1 }]">
                  更全面的园区信息
                </div>
                <img class="img1" src="../../assets/img/d-2-3.png" />
                <div class="marker">
                  <div class="marker1 wait settime">
                    <!-- <div class="time ">等待<span>10</span>分钟</div> -->
                  </div>
                  <div class="marker2 wait settime2">
                    <!-- <div class="time">等待<span>30</span>分钟</div> -->
                  </div>
                  <div class="marker3 wait settime3">
                    <!-- <div class="time">等待<span>60</span>分钟</div> -->
                  </div>
                </div>
              </swiper-slide>

              <swiper-slide class="three">
                <div id="threee" :class="['title', { 'title-hidden': activeSlide !== 2 }]">
                  更生动的主题故事
                </div>
                <img class="img1" src="../../assets/img/3-3.png" alt="" />
                <div class="outsilde">
                  <img
                    id="hp"
                    class="hp"
                    src="../../assets/img/dragon.png"
                    alt=""
                  />
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <div class="bottom">
          <img src="../../assets/img/CNlogo@2x.png" alt="" />
          <button @click="Isweixin('CH')"><span>立即下载</span></button>
        </div>
      </div>
    </div>
    <div class="Home" v-if="!isin">
      <!--英文版 -->
      <div>
        <div class="main">
          <div class="toast" v-show="toastShow">
            {{ toasttext }}
          </div>
          <!-- <div class="text stext" id="text">
            <div id="onee" class="oneee" style="transition: all 500ms ease 0s;">
              <div style="margin-bottom:.05rem">More Timely</div>
              <div>Park Dynamics</div>
            </div>
            <div id="twoo" class="twooo" style="transition: all 500ms ease 0s;">
              <div style="margin-bottom:.05rem">More Comprehensive</div>
              <div>Park Information</div>
            </div>
            <div
              id="threee"
              class="threeee"
              style="transition: all 500ms ease 0s;"
            >
              <div style="margin: 0.1rem 0 ">More Vivid Theme Land</div>
            </div>
          </div> -->
          <div class="Tips">
            <div
              style="
                display: flex;
                justify-content: space-between;
                width: 110%;
                transform: scale(0.9);
                position: relative;
                left: -18px;
              "
            >
              <div class="developer">Developer：尤尼维瑟(北京)咨询有限公司</div>
              <div class="edition">Universal BJ {{ version }}</div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: 7px;
                width: 110%;
                transform: scale(0.9);
                position: relative;
                left: -18px;
              "
            >
              <div class="operate">
                <span @click="power">Permission</span> |
                <span @click="privacy">Information Protection</span>
              </div>
              <div class="renew">{{ updateDateEn }} Update</div>
            </div>
          </div>
          <div class="bo-1">
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide
                class="one"
              >
                <div
                  id="onee"
                  :class="['oneee', 'title', { 'title-hidden': activeSlide !== 0 }]"
                >
                  <div style="margin-bottom: 0.05rem">More Timely</div>
                  <div>Park Dynamics</div>
                </div>
                <img class="img1" src="../../assets/img/en-1-3.png" alt="" />
                <div class="imgsilde">
                  <img
                    class="img2"
                    src="../../assets/img/logo-apng.png"
                    alt=""
                  />
                </div>
              </swiper-slide>

              <swiper-slide class="two">
                <div
                  id="twoo"
                  :class="['twooo', 'title', { 'title-hidden': activeSlide !== 1 }]"
                >
                  <div style="margin-bottom: 0.05rem">More Comprehensive</div>
                  <div>Park Information</div>
                </div>
                <img class="img1" src="../../assets/img/en-2-3.png" />
                <div class="marker markeren">
                  <div class="marker1 wait settime">
                    <!-- <div class="time">Wait<span>10</span>Mins</div> -->
                  </div>
                  <div class="marker2 wait settime2">
                    <!-- <div class="time">Wait<span>30</span>Mins</div> -->
                  </div>
                  <div class="marker3 wait settime3">
                    <!-- <div class="time">Wait<span>60</span>Mins</div> -->
                  </div>
                </div>
              </swiper-slide>

              <swiper-slide class="three">
                <div id="threee" :class="['threeee', 'title', 'title-en-three-offset', { 'title-hidden': activeSlide !== 2 }]">
                  <div style="margin: 0.1rem 0">More Vivid Themed Stories</div>
                </div>
                <img class="img1" src="../../assets/img/3-3.png" alt="" />
                <div class="outsilde">
                  <img
                    id="hp"
                    class="hp"
                    src="../../assets/img/dragon.png"
                    alt=""
                  />
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <div class="bottom">
          <img
            src="../../assets/img/ENlogo@2x.png"
            alt=""
          />
          <button @click="Isweixin('EN')"><span class="bottom-en-text">Download</span></button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { xm_bi } from '../path/initAnalysis.js'
import utils from "../path/utils.js";
import { GetNewsList, GetDownloadurl } from "@ajax";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import Swiper6, { Navigation, Pagination, Autoplay } from "swiper";
import hyLoad from "huyue-tools-load";
Swiper6.use([Autoplay, Navigation, Pagination]);
import { whenAPIReady, versionUpdate } from "@/utils/util";
import uaParser from "ua-parser-js";
export default {
  name: "Home",
  data() {
    return {
      version: "",
      updateDate: "",
      updateDateEn: "",
      Androidstate: false, //判断是否在安卓App内部
      toastShow: false,
      isin: "0",
      activeSlide: 0,
      toasttext: "请在手机浏览器中打开链接",
      swiperOptions: {
        loop: true, //循环,
        simulateTouch: true, //禁止鼠标模拟,
        allowTouchMove: false, //触摸滑动
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: false,
        speed: 1000,
        effect: "slide",
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // autoplay: false,
        autoplay: {
          delay: 3000, //3秒切换一次
          disableOnInteraction: false,
        },
      },
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  created() {
    // 兼容QQ浏览器 "#/home"
    let origin = window.location.href.split("?")[0];
    let str = window.location.href.split("?")[1];
    if (
      window.location.href.indexOf("?") != -1 &&
      str.indexOf("#/home") != -1
    ) {
      // console.log('home+++++')
      // console.log(str.split('#/home')[0])
      // console.log( window.location.origin,'origin')
      window.location = origin + "#/home?" + str.split("#/home")[0];
    } else {
      // 页面到达上报
      TDAPP.onEvent("arrive_app_download");
      gdp("track", "arrive_app_download");

      //判断 中英文
      this.language();

      // GetNewsList().then((res) => {
      //   this.isin = res.data.is_in;
      //   console.log(res);
      //   console.log('----' + this.isin);
      // });
      // scheme
      // decodeURIComponent('ubrmb%3A%2F%2FshowDetail%3Fid%3Dxxx%26type%3Dshow#/home')
      let url = utils.getUrlKey("scheme");
      // console.log(url)
      var u = navigator.userAgent;
      const isChrome = uaParser(u).browser.name === "Chrome";
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        if (url != null) {
          var reg = RegExp(/ubrmb/);
          if (url.match(reg)) {
            window.location = url;
          }
        }
      } else {
        if (isChrome) {
          if (url != null) {
            var reg = RegExp(/ubrmb/);
            if (url.match(reg)) {
              window.location = url;
            }
          }
        } else {
          const _iframe = document.createElement("iframe");
          _iframe.id = "iframe";
          if (url != null) {
            var reg = RegExp(/ubrmb/);
            if (url.match(reg)) {
              // console.log('jin')
              _iframe.src = url;
            }
          } else {
            _iframe.src = "";
          }
          document.body.appendChild(_iframe);
          setTimeout(function () {
            var id = document.getElementById("iframe");
            document.body.removeChild(id);
          }, 5000);
        }
      }
      // 调用 下载落地页安卓下载地址、版本号、隐私政策更新日期
      // 先空着，接口有值用接口，没值或报错再用 .env 默认值，避免先默认后接口闪一下
      GetDownloadurl()
        .then((res) => {
          const data = (res && res.data) || {};
          const env = process.env || {};
          this.android_file_url = data.url;
          this.version = data.version || env.VUE_APP_VERSION || "";
          this.updateDate = data.date_ch || env.VUE_APP_DATE || "";
          this.updateDateEn = data.date_en || env.VUE_APP_DATE_EN || "";
        })
        .catch(() => {
          const env = process.env || {};
          this.version = env.VUE_APP_VERSION || "";
          this.updateDate = env.VUE_APP_DATE || "";
          this.updateDateEn = env.VUE_APP_DATE_EN || "";
        });
    }
  },
  mounted() {
    this.$refs.mySwiper.$swiper;
    if (this.swiper) {
      this.activeSlide = this.swiper.realIndex || 0;
      this.swiper.on("slideChangeTransitionStart", () => {
        this.activeSlide = this.swiper.realIndex;
      });
    }
    whenAPIReady().then(() => {
      this.Androidstate = true;
      console.log(window.__SystemInfo__.language); //判断iosAPP语言
      if (window.__SystemInfo__.language === "EN") {
        this.isin = false;
      }
    });
    // console.log("Current Swiper instance object", this.swiper);
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },

  methods: {
    // 判断中英文
    language() {
      let urlLang = "";
      if (navigator && navigator.language) {
        urlLang = navigator.language;
      }
      console.log(urlLang, "--------");
      if (urlLang) {
        if (urlLang.indexOf("en") > -1 || urlLang.indexOf("EN") > -1) {
          this.isin = false;
        } else {
          this.isin = true;
        }
      }
    },
    // 判断 微信浏览器
    Isweixin(type) {
      //is_weixin 会返回一个true 和flase  是微信浏览器打开返回true  不是返回false
      var is_weixin = (function () {
        return (
          navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
        );
      })();
      if (is_weixin) {
        //如果是微信执行的操作
        if (type === "CH") {
          this.toasttext = "请用其他浏览器进行下载";
          this.toastShow = true;
          let that = this;
          setTimeout(function () {
            that.toastShow = false;
          }, 5000);
        } else if (type === "EN") {
          this.toasttext = "Please use another browser to download";
          this.toastShow = true;
          let that = this;
          setTimeout(function () {
            that.toastShow = false;
          }, 5000);
        }
      } else {
        //如果不是微信执行的操作
        if (type === "CH") {
          this.CNdownloadApp();
        } else if (type === "EN") {
          this.ENdownloadApp();
        }
      }
      // let parameter = utils.getUrlKey('utm_source')
      // if (parameter != null) {
      //   // console.log(parameter)
      //   TDAPP.onEvent(parameter)
      //   gdp('track', parameter)
      // } else {
      //   TDAPP.onEvent('')
      // }
      // 点击上报
      TDAPP.onEvent("click_app_download_install");
      gdp("track", "click_app_download_install");
    },
    // 判断为国内
    CNdownloadApp() {
      console.log("国内");
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var isPc = !isAndroid && !isiOS; //pc端
      if (isAndroid) {
        console.log("国内android");
        // 交互方法名称：versionUpdate()
        console.log(this.Androidstate, "Androidstate");
        if (!this.Androidstate) {
          //修改下载地址
          window.location = this.android_file_url;
          // let a = document.createElement('a')
          // let event = new MouseEvent('click')
          // a.href = this.android_file_url
          // a.download = 'Android_UniversalBeijingResort'
          // a.dispatchEvent(event)
        } else {
          console.log("APP内部ch");
          versionUpdate();
        }
        this.toastShow = false;
      }
      if (isiOS) {
        console.log("国内ios");
        window.location = "https://itunes.apple.com/app/id1535766300";
        this.toastShow = false;
      }
      if (isPc) {
        this.toasttext = "请在手机浏览器中打开链接";
        this.toastShow = true;
        let v = this;
        setTimeout(function () {
          v.toastShow = false;
        }, 1500);
      }
    },
    // 判断为国外
    ENdownloadApp() {
      console.log("国外");
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var isPc = !isAndroid && !isiOS; //pc端
      if (isAndroid) {
        console.log("国内android");
        // 交互方法名称：versionUpdate()
        console.log(this.Androidstate, "Androidstate");
        if (!this.Androidstate) {
          window.location = this.android_file_url;
        } else {
          console.log("APP内部en");
          versionUpdate();
        }
        this.toastShow = false;
      }
      if (isiOS) {
        window.location = "https://itunes.apple.com/app/id1535766300";
        this.toastShow = false;
      }
      if (isPc) {
        this.toasttext = "Please open the link in the mobile browser";
        this.toastShow = true;
        let v = this;
        setTimeout(function () {
          v.toastShow = false;
        }, 1500);
      }
    },
    // 跳转权限
    power() {
      console.log(this.isin);
      if (this.isin) {
        window.location.href =
          "https://cdn.app.universalbeijingresort.com/h5/h5pro/dist/index.html#/?language=ch&id=612d9e652e82166dca5aebaa";
      } else {
        window.location.href =
          "https://cdn.app.universalbeijingresort.com/h5/h5pro/dist/index.html#/?language=en&id=612d9e652e82166dca5aebaa";
      }
    },
    // 跳转隐私政策
    privacy() {
      console.log(this.isin);
      if (this.isin) {
        window.location.href =
          "https://cdn.app.universalbeijingresort.com/h5/h5pro/dist/index.html#/?language=ch&id=5ffc83c46d0dcb044c507ed4";
      } else {
        window.location.href =
          "https://cdn.app.universalbeijingresort.com/h5/h5pro/dist/index.html#/?language=en&id=5ffc83c46d0dcb044c507ed4";
      }
    },
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  -webkit-transform: translateZ(0px);
  perspective: 500;
  -webkit-perspective: 500;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
}
body {
  -webkit-overflow-scrolling: touch;
  -webkit-transform: translateZ(0px);
  perspective: 500;
  -webkit-perspective: 500;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
}
iframe {
  position: absolute;
  top: -100%;
}
@media (max-width: 800px) {
  html {
    font-size: 26.666vw !important;
  }
  .Home {
    height: 79%;
    width: 100%;
    background-color: #0368d9;
  }
  .Tips {
    width: 100%;
    height: auto;
    padding: 9px 20px;
    background: #ffffff;
    div {
      display: inline-block;
      font-family: PingFangSC-Regular;
      color: #757575;
      font-size: 10px;
      letter-spacing: 0;
      line-height: 15px;
      // border: 1px solid;
    }
    .edition {
      text-align: right;
    }
    .renew {
      text-align: right;
    }
  }
  .main {
    // height: 4.24rem;
    height: 5.75rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .toast {
      position: fixed;
      z-index: 2000;
      left: 50%;
      top: 45%;
      transition: all 0.5s;
      -webkit-transform: translateX(-50%) translateY(-50%);
      -moz-transform: translateX(-50%) translateY(-50%);
      -ms-transform: translateX(-50%) translateY(-50%);
      -o-transform: translateX(-50%) translateY(-50%);
      transform: translateX(-50%) translateY(-50%);
      text-align: center;
      border-radius: 0.25rem;
      color: #fff;
      background: rgba(17, 17, 17, 0.8);
      line-height: 0.4rem;
      padding: 0 0.3rem;
      width: 2.3rem;
      font-size: 0.14rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
    .stext {
      position: absolute;
      text-align: center;
      width: 100%;
    }
    .text {
      font-size: 0.24rem;
      font-family: MXiangHeHeiSCStd-Heavy, MXiangHeHeiSCStd;
      font-weight: 800;
      color: #ffffff;
      margin: 0.35rem 0;
      #onee {
        opacity: 1;
      }
      #twoo {
        opacity: 0;
        margin-top: -0.24rem;
      }
      .twooo {
        margin-top: -0.48rem !important;
      }
      #threee {
        opacity: 0;
        margin-top: -0.24rem;
      }
      .threeee {
        margin-top: -0.55rem !important;
      }
    }
    .bo-1 {
      width: 100%;
      height: 5.63rem;
      background: transparent;
      overflow: hidden;
      .swiper-container {
        z-index: 99;
        overflow: hidden;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
        .swiper-wrapper {
          z-index: 99;
          transform: translate3d(0, 0, 0);
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
        }
      }
      .swiper-slide {
        text-align: center;
        font-size: 0.18rem;
        display: flex;
        justify-content: center;
        align-items: baseline !important;
        background-color: transparent !important;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
        &.one {
          background-image: url(../../assets/img/bg1.png);
        }
        &.two {
          background-image: url(../../assets/img/bg2.png);
        }
        &.three {
          background-image: url(../../assets/img/bg3.png);
        }
      }
      @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
        .swiper-slide {
          &.one {
            background-image: url(../../assets/img/bg1@2x.png);
          }
          &.two {
            background-image: url(../../assets/img/bg2@2x.png);
          }
          &.three {
            background-image: url(../../assets/img/bg3@2x.png);
          }
        }
      }
      .img1 {
        position: absolute;
        top: 0.78rem;
        width: 2.75rem;
        height: 5.5rem;
        border-radius: 0.28rem;
        box-shadow: 0px 0.04rem 0.3rem 0px #004aa04d;
      }
      .img2 {
        position: relative;
        top: 0.78rem;
        width: 1.3rem;
        height: 1.11rem;
        margin-top: 0.53rem;
      }
      .marker {
        display: none;
        position: absolute;
        top: 0.78rem;
        width: 100%;
        height: 100%;
        z-index: 165;
        .marker1 {
          margin-top: 0.95rem;
          margin-left: 2.61rem;
          animation: warn 500ms ease;
          animation-delay: 1.0s;
          animation-fill-mode: both;
        }
        .marker2 {
          margin-top: 2.55rem;
          margin-left: 1.73rem;
          animation: warn 500ms ease;
          animation-delay: 1.3s;
          animation-fill-mode: both;
        }
        .marker3 {
          margin-top: 0.37rem;
          margin-left: 1.45rem;
          animation: warn 500ms ease;
          animation-delay: 1.6s;
          animation-fill-mode: both;
        }
        .wait {
          position: absolute;
          background-repeat: no-repeat;
          background-size: 0.9rem 0.95rem;
          width: 0.9rem;
          height: 0.95rem;
          border-radius: 35%;
          display: flex;
          justify-content: center;
          align-items: center;
          div {
            width: 0.27rem;
            font-size: 0.1rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            text-shadow: 0rem 0.12rem 0.48rem rgba(0, 0, 0, 0.3);
            span {
              display: block;
              height: 0.2rem;
              font-size: 0.19rem;
              font-family: AvenirNextLTPro-Heavy, AvenirNextLTPro;
              font-weight: 800;
              color: #333333;
              line-height: 0.19rem;
              text-shadow: 0px 0.12rem 0.48rem rgba(0, 0, 0, 0.3);
              margin: 0.01rem 0;
            }
          }
        }
        .settime {
          background-image: url(../../assets/img/time-ch-1.png);
        }
        .settime2 {
          background-image: url(../../assets/img/time-ch-2.png);
        }
        .settime3 {
          background-image: url(../../assets/img/time-ch-3.png);
        }
        @keyframes warn {
          from {
            transform: scale(0);
          }
          10% {
            transform: scale(0.1);
          }
          20% {
            transform: scale(0.2);
          }
          30% {
            transform: scale(0.3);
          }
          40% {
            transform: scale(0.5);
          }
          50% {
            transform: scale(0.7);
          }
          60% {
            transform: scale(0.9);
          }
          70% {
            transform: scale(1);
          }
          80% {
            transform: scale(1.1);
          }
          90% {
            transform: scale(1.2);
          }
          95% {
            transform: scale(1.1);
          }
          100% {
            transform: scale(1);
          }
        }
      }
      .swiper-slide-active.two {
        .marker {
          display: block;
        }
      }
      .markeren {
        .settime {
          background-image: url(../../assets/img/time-en-1.png);
        }
        .settime2 {
          background-image: url(../../assets/img/time-en-2.png);
        }
        .settime3 {
          background-image: url(../../assets/img/time-en-3.png);
        }
      }
      .outsilde {
        position: absolute;
        width: 3.75rem;
        height: 4rem;
        z-index: 150;
        top: -15px;
        overflow-x: hidden;
        animation: bounce-down 2s linear infinite;
      }
      .title {
        position: absolute;
        z-index: 180;
        width: 3.75rem;
        height: 0.78rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        white-space: normal;
        word-break: break-word;
        text-align: center;
        font-size: 0.26rem;
        font-family: MXiangHeHeiSCStd-Heavy, MXiangHeHeiSCStd;
        font-weight: 750;
        color: #ffffff;
        line-height: 0.34rem;
      }
      .title-hidden {
        opacity: 0;
      }
      .title-en-three-offset {
        margin-top: 0rem;
      }
      .oneee,
      .twooo,
      .threeee {
        font-size: 0.22rem;
        line-height: 0.27rem;
        div{
          font-family: AvenirNextLTPro-Bold, AvenirNextLTPro;
        }
      }
      .hp {
        width: 9rem !important;
        height: 4rem !important;
        margin-top: -1.32rem !important;
        z-index: 150;
        // right: -1.33rem;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
      }
      @keyframes bounce-down {
        25% {
          transform: translateY(-15px);
        }
        50%,
        100% {
          transform: translateY(0);
        }
        75% {
          transform: translateY(15px);
        }
      }
      .swiper-container {
        width: 100%;
        height: 100%;
      }
    }
  }
  .bottom {
    background-image: url(../../assets/img/bottom.png);
    background-repeat: no-repeat;
    background-size: 102%;
    width: 100%;
    height: 3rem;
    position: absolute;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -1.4rem;
    img {
      height: 0.56rem;
      margin-top: 1.24rem;
      margin-bottom: 0.25rem;
    }
    button {
      width: 3.15rem;
      height: 0.5rem;
      background: #0368d9;
      border-radius: 0.25rem;
      border: none;
      outline: none;
      span {
        height: 0.18rem;
        font-size: 0.18rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 0.18rem;
      }
      .bottom-en-text {
        font-size: 0.18rem;
        font-weight: 700;
        font-family: AvenirNextLTPro-Heavy, AvenirNextLTPro;
      }
    }
  }
}

@media (min-width: 801px) {
  .Home {
    height: 79%;
    width: 100%;
    // background-color: #0368d9;
  }
  .Tips {
    width: 375px !important;
    height: auto;
    padding: 9px 20px;
    background: #ffffff;
    div {
      display: inline-block;
      font-family: PingFangSC-Regular;
      color: #757575;
      font-size: 10px;
      letter-spacing: 0;
      line-height: 15px;
      // border: 1px solid;
    }
    .edition {
      text-align: right;
    }
    .renew {
      text-align: right;
    }
  }
  .main {
    // height: 4.24rem;
    height: 575px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .toast {
      position: fixed;
      z-index: 2000;
      left: 50%;
      top: 45%;
      transition: all 0.5s;
      -webkit-transform: translateX(-50%) translateY(-50%);
      -moz-transform: translateX(-50%) translateY(-50%);
      -ms-transform: translateX(-50%) translateY(-50%);
      -o-transform: translateX(-50%) translateY(-50%);
      transform: translateX(-50%) translateY(-50%);
      text-align: center;
      border-radius: 25px;
      color: #fff;
      background: rgba(17, 17, 17, 0.8);
      line-height: 40px;
      padding: 0 30px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
    .stext {
      position: absolute;
      text-align: center;
      width: 100%;
    }
    .text {
      font-size: 24px;
      font-family: MXiangHeHeiSCStd-Heavy, MXiangHeHeiSCStd;
      font-weight: 800;
      color: #ffffff;
      // margin: 35px 0;
      padding-bottom: 41px;
      padding-top: 35px;
      width: 375px !important;
      background-color: #0368d9;
      #onee {
        opacity: 1;
      }
      #twoo {
        opacity: 0;
        margin-top: -24px;
      }
      .twooo {
        margin-top: -48px !important;
      }
      #threee {
        opacity: 0;
        margin-top: -24px;
      }
      .threeee {
        margin-top: -55px !important;
      }
    }
    .bo-1 {
      width: 100%;
      height: 510px;
      // margin-top: 100px;
      // background: #0368d9;
      overflow: hidden;
      .swiper-container {
        z-index: 99;
        width: 375px !important;
        background-color: transparent;
        overflow: hidden;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
        .swiper-wrapper {
          z-index: 99;
          transform: translate3d(0, 0, 0);
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
        }
      }
      .swiper-slide {
        text-align: center;
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: baseline !important;
        background-color: transparent !important;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
        &.one {
          background-image: url(../../assets/img/bg1.png);
        }
        &.two {
          background-image: url(../../assets/img/bg2.png);
        }
        &.three {
          background-image: url(../../assets/img/bg3.png);
        }
      }
      @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
        .swiper-slide {
          &.one {
            background-image: url(../../assets/img/bg1@2x.png);
          }
          &.two {
            background-image: url(../../assets/img/bg2@2x.png);
          }
          &.three {
            background-image: url(../../assets/img/bg3@2x.png);
          }
        }
      }
      .img1 {
        position: absolute;
        top: 78px;
        width: 275px;
        height: 550px;
        border-radius: 28px;
        box-shadow: 0px 4px 30px 0px #004aa04d;
      }
      .img2 {
        position: relative;
        top: 78px;
        width: 130px;
        height: 111px;
        margin-top: 53px;
      }
      .marker {
        display: none;
        position: absolute;
        top: 78px;
        width: 100%;
        height: 100%;
        z-index: 165;
        .marker1 {
          margin-top: 95px;
          margin-left: 261px;
          animation: warn 500ms ease;
          animation-delay: 1.0s;
          animation-fill-mode: both;
        }
        .marker2 {          
          margin-top: 255px;
          margin-left: 173px;
          animation: warn 500ms ease;
          animation-delay: 1.3s;
          animation-fill-mode: both;
        }
        .marker3 {
          margin-top: 37px;
          margin-left: 145px;
          animation: warn 500ms ease;
          animation-delay: 1.6s;
          animation-fill-mode: both;
        }
        .wait {
          position: absolute;
          background-repeat: no-repeat;
          background-size: 90px 95px;
          width: 90px;
          height: 95px;
          border-radius: 35%;
          display: flex;
          justify-content: center;
          align-items: center;
          div {
            width: 27px;
            font-size: 10px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            text-shadow: 0px 12px 48px rgba(0, 0, 0, 0.3);
            span {
              display: block;
              height: 20px;
              font-size: 19px;
              font-family: AvenirNextLTPro-Heavy, AvenirNextLTPro;
              font-weight: 800;
              color: #333333;
              line-height: 19px;
              text-shadow: 0px 12px 48px rgba(0, 0, 0, 0.3);
              margin: 1px 0;
            }
          }
        }
        .settime {
          background-image: url(../../assets/img/time-ch-1.png);
        }
        .settime2 {
          background-image: url(../../assets/img/time-ch-2.png);
        }
        .settime3 {
          background-image: url(../../assets/img/time-ch-3.png);
        }

        @keyframes warn {
          from {
            transform: scale(0);
          }
          10% {
            transform: scale(0.1);
          }
          20% {
            transform: scale(0.2);
          }
          30% {
            transform: scale(0.3);
          }
          40% {
            transform: scale(0.5);
          }
          50% {
            transform: scale(0.7);
          }
          60% {
            transform: scale(0.9);
          }
          70% {
            transform: scale(1);
          }
          80% {
            transform: scale(1.1);
          }
          90% {
            transform: scale(1.2);
          }
          95% {
            transform: scale(1.1);
          }
          100% {
            transform: scale(1);
          }
        }
      }
      .swiper-slide-active.two {
        .marker {
          display: block;
        }
      }
      .markeren {
        .settime {
          background-image: url(../../assets/img/time-en-1.png);
        }
        .settime2 {
          background-image: url(../../assets/img/time-en-2.png);
        }
        .settime3 {
          background-image: url(../../assets/img/time-en-3.png);
        }
      }
      .outsilde {
        position: absolute;
        width: 375px;
        height: 400px;
        z-index: 150;
        top: -15px;
        overflow-x: hidden;
        animation: bounce-down 2s linear infinite;
      }
      .title {
        position: absolute;
        z-index: 180;
        width: 375px;
        height: 78px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        white-space: normal;
        word-break: break-word;
        text-align: center;
        font-size: 26px;
        font-family: MXiangHeHeiSCStd-Heavy, MXiangHeHeiSCStd;
        font-weight: 750;
        color: #ffffff;
        line-height: 34px;
      }
      .title-hidden {
        opacity: 0;
      }
      .title-en-three-offset {
        margin-top: 0;
      }
      .oneee,
      .twooo,
      .threeee {
        font-size: 22px;
        line-height: 27px;
        div {
          font-family: AvenirNextLTPro-Bold, AvenirNextLTPro;
        }
      }
      .hp {
        width: 900px !important;
        height: 400px !important;
        margin-top: -132px !important;
        position: relative;
        z-index: 100;
        left: 50%;
        transform: translateX(-50%);
      }
      @keyframes bounce-down {
        25% {
          transform: translateY(-15px);
        }
        50%,
        100% {
          transform: translateY(0);
        }
        75% {
          transform: translateY(15px);
        }
      }
      .swiper-container {
        width: 100%;
        height: 100%;
      }
    }
  }
  .bottom {
    background-image: url(../../assets/img/bottom@2x.png);
    background-repeat: no-repeat;
    background-size: 102%;
    width: 100%;
    height: 300px;
    position: absolute;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -140px;
    width: 376px !important;
    left: 50%;
    transform: translateX(-50%);
    img {
      height: 56px;
      margin-top: 124px;
      margin-bottom: 25px;
    }
    button {
      width: 315px;
      height: 50px;
      background: #0368d9;
      border-radius: 25px;
      border: none;
      outline: none;
      span {
        height: 18px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 18px;
      }
      .bottom-en-text {
        font-size: 18px;
        font-weight: 700;
        font-family: AvenirNextLTPro-Heavy, AvenirNextLTPro;
      }
    }
  }
}
</style>
